<template>
  <!-- Site wrapper -->
  <div class="wrapper" v-show="false">
    <cabecalho tituloPagina="Login" />
    <menuLateral />
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import constants from '@/util/constants'
import { mapActions } from 'vuex'
import util from '@/util'
import cookieUtil from '@/util/cookieUtil'

export default {
  name: 'loginGestaoConta',
  components: {
    cabecalho,
    menuLateral
  },
  mounted () {
    this.executeLogin()
  },
  methods: {
    ...mapActions('auth', ['ActionSetLoginStrategy', 'ActionSetNomeUsuarioLogado', 'ActionSetNomeEmpresa', 'ActionSetCpfCnpj', 'ActionSetEmailUsuario', 'ActionSignOut']),

    async executeLogin () {
      let urlHash = window.location.hash
      if (urlHash !== null && urlHash !== undefined && urlHash.length > 0) {
        const indicePontoInterrogacao = urlHash.indexOf('?')
        if (indicePontoInterrogacao === -1) {
          return false
        }
        urlHash = urlHash.substring(indicePontoInterrogacao)
        const urlParams = new URLSearchParams(urlHash)
        let token = urlParams.get('token')
        token = (token === undefined || token === null ? '' : token.trim())
        let objetoRotaInicial = this.definirRotaInicial(urlParams)
        try {
          await cookieUtil.gerarCookieTokenCsrf()
          const loginRequestConfig = {
            headers: { Authorization: `Bearer ${token}` }
          }
          const resposta = await this.axios.post('manager/conta/login', {}, loginRequestConfig)
          const sucesso = resposta.data.success
          if (sucesso === true) {
            this.ActionSignOut()
            this.ActionSetLoginStrategy(resposta.data.login_strategy)
            this.ActionSetNomeUsuarioLogado(resposta.data.f_user_name)
            this.ActionSetNomeEmpresa(resposta.data.office_name)
            this.ActionSetEmailUsuario(resposta.data.user_mail)
            if (!util.valorVazio(resposta.data.cpf_cnpj)) {
              this.ActionSetCpfCnpj(resposta.data.cpf_cnpj)
            } else {
              this.ActionSetCpfCnpj('')
            }
            this.$router.push(objetoRotaInicial)
          }
        } catch (e) {
          console.log(e)
        }
      }
    },

    definirRotaInicial (urlParams) {
      let rota = urlParams.get('rota')
      rota = (rota === undefined || rota === null ? '' : rota.trim())
      const objetoDaRota = this.definirObjetoDaRota(rota, urlParams)
      return objetoDaRota
    },

    definirObjetoDaRota (rota, urlParams) {
      const { nomeRotaMercado, nomeRotaAlterarPlano, nomeRotaListagemFaturas, nomeRotaInicioAreaGestaoConta } = constants
      switch (rota) {
        case nomeRotaMercado:
          return this.obterRotaMercado(urlParams)
        case nomeRotaAlterarPlano:
          return { name: nomeRotaAlterarPlano }
        case nomeRotaListagemFaturas:
          return { name: nomeRotaListagemFaturas }
        default:
          return { name: nomeRotaInicioAreaGestaoConta }
      }
    },

    obterRotaMercado (urlParams) {
      let idProduto = urlParams.get('idProduto')
      idProduto = util.valorVazio(idProduto) ? null : idProduto.trim()
      return idProduto
        ? { name: constants.nomeRotaMercado, params: { 'idProduto': idProduto } }
        : { name: constants.nomeRotaMercado }
    }
  }
}
</script>
